export const SET_FILTER_DATA = "SET_FILTER_DATA";
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const CREATE_COMMON_CATEGORIES = "CREATE_COMMON_CATEGORIES";
export const TOGGLE_SEARCH_FILTER = "TOGGLE_SEARCH_FILTER";
export const SET_CATEGORIES_DATA = "SET_CATEGORIES_DATA";
export const SET_MEET_PEOPLE_INTERESTS_DATA = "SET_MEET_PEOPLE_INTERESTS_DATA";
